import { Link as RouterLink } from 'react-router-dom'
import Button from '@mui/material/Button'
import { forgotPasswordOutlineButtonSx } from '../styles/forgotPasswordStyles'

type BackToLoginButtonProps = {
  readonly variant?: 'text' | 'outlined'
}

/** Figma 5074-11993 — outlined "Back to Login" on forgot-password flows. */
export function BackToLoginButton({ variant = 'outlined' }: BackToLoginButtonProps) {
  if (variant === 'text') {
    return (
      <Button
        component={RouterLink}
        to="/login"
        variant="text"
        data-testid="back-to-login"
        sx={{
          mt: 2,
          color: '#008cd0',
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '14px',
        }}
      >
        Back to Login
      </Button>
    )
  }

  return (
    <Button
      component={RouterLink}
      to="/login"
      variant="outlined"
      fullWidth
      disableElevation
      data-testid="back-to-login"
      sx={{
        ...forgotPasswordOutlineButtonSx,
        '&.MuiButton-outlinedPrimary': {
          borderWidth: '1.5px',
        },
      }}
    >
      Back to Login
    </Button>
  )
}
